<h1 mat-dialog-title>{{'New connector {0}'|i18n:(form.controls.id.value || '')}}</h1>
<div mat-dialog-content fxLayout="column" class="new-connector-dialog">
    <form novalidate [formGroup]="form" fxLayout="column">
        <mat-form-field>
            <input matInput placeholder="{{'Id'|i18n}}" formControlName="id">
            <mat-error *ngIf="form.controls.id.hasError('empty')">
                {{'Invalid id'|i18n}}
            </mat-error>
            <mat-error *ngIf="form.controls.id.hasError('duplicate')">
                {{'Id already exists'|i18n}}
            </mat-error>
        </mat-form-field>
        <mat-form-field>
            <mat-select placeholder="{{'Type'|i18n}}" formControlName="type"
                        (selectionChange)="onSelectConnectorType($event)">
                <mat-select-trigger>
                    <ng-container *ngIf="form.controls.type.value as type">{{type|connectorType}}</ng-container>
                </mat-select-trigger>
                <mat-option *ngFor="let type of CONNECTOR_TYPES" [value]="type">
                    <ng-container *ngIf="type">{{type|connectorType}}</ng-container>
                </mat-option>
            </mat-select>
            <mat-error *ngIf="!form.controls.type.valid">
                {{'Invalid type'|i18n}}
            </mat-error>
        </mat-form-field>
        <ng-container [ngSwitch]="form.controls.type.value">
            <ng-container *ngSwitchCase="ConfigType.BACNET">
                <mat-form-field class="mt-8">
                    <input matInput placeholder="{{'Host'|i18n}}" formControlName="host">
                    <mat-error *ngIf="!form.controls.host.valid">
                        {{'Invalid host'|i18n}}
                    </mat-error>
                </mat-form-field>
                <mat-form-field>
                    <input matInput placeholder="{{'BBDM'|i18n}}" formControlName="bbdm">
                    <mat-error *ngIf="!form.controls.bbdm.valid">
                        {{'Invalid BBDM'|i18n}}
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="mb-8">
                    <input matInput placeholder="{{'TTL'|i18n}}" formControlName="ttl" type="number">
                    <mat-error *ngIf="!form.controls.ttl.valid">
                        {{'Invalid TTL'|i18n}}
                    </mat-error>
                </mat-form-field>
            </ng-container>
            <ng-container *ngSwitchCase="ConfigType.METEO">
                <mat-form-field class="mt-8" [ngClass]="{'mb-8': !form.controls.srcType.value}">
                    <mat-select placeholder="{{'Source type'|i18n}}" formControlName="srcType"
                                (selectionChange)="onMeteoSourceTypeChange($event)">
                        <mat-option *ngFor="let srcType of METEO_SRC_TYPES" [value]="srcType">
                            {{srcType|meteoSourceType}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls.srcType.valid">
                        {{'Invalid source type'|i18n}}
                    </mat-error>
                </mat-form-field>
                <ng-container [ngSwitch]="form.controls.srcType.value">
                    <ng-container *ngSwitchCase="SourceType.METEOMATICS">
                        <mat-form-field>
                            <input matInput placeholder="{{'API url'|i18n}}" formControlName="apiUrl">
                            <mat-error *ngIf="!form.controls.apiUrl.valid">
                                {{'Invalid API url'|i18n}}
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput placeholder="{{'User name'|i18n}}" formControlName="user"
                                   autocomplete="username">
                            <mat-error *ngIf="!form.controls.user.valid">
                                {{'Invalid user name'|i18n}}
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="mb-8">
                            <input matInput placeholder="{{'Password'|i18n}}" formControlName="pass"
                                   type="password" autocomplete="current-password">
                            <mat-error *ngIf="!form.controls.pass.valid">
                                {{'Invalid password'|i18n}}
                            </mat-error>
                        </mat-form-field>
                    </ng-container>
                </ng-container>
            </ng-container>
        </ng-container>
    </form>
</div>
<div mat-dialog-actions class="actions">
    <button mat-stroked-button color="primary" [disabled]="!form.valid"
            [mat-dialog-close]="close()">
        <app-icon name="fal-save"></app-icon>&nbsp;&nbsp;
        {{'Add'|i18n}}
    </button>
</div>
